<template>
  <img
    :src="image"
    :width="width"
  >
</template>

<script>
export default {
  name: 'Flag',

  props: {
    locale: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '24px'
    }
  },

  computed: {
    image () {
      return `/static/images/flags/${this.locale}.png`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Flag.vue